<template>
  <a-drawer
    :title="(action == 'add' ? '添加' : '修改') + '巡查路线'"
    :width="400"
    :visible="visible"
    @close="
      $emit('update:visible', false);
      form.resetFields();
    "
  >
    <a-form
      :form="form"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      @submit="handleOk"
    >
      <a-form-item label="id" v-show="false">
        <a-input v-decorator="['id']"> </a-input>
      </a-form-item>
      <a-form-item label="路线名称">
        <a-input
          placeholder="请选择路线名称"
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请选择路线名称' }] }
          ]"
        >
        </a-input>
      </a-form-item>
    </a-form>

    <div class="drawer-btn">
      <a-button
        :style="{ marginRight: '8px' }"
        @click="
          $emit('update:visible', false);
          form.resetFields();
        "
      >
        取消
      </a-button>
      <a-button type="primary" @click="handleOk">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { addPatrolRoute, updatePatrolRoute } from "@/api/api";
import moment from "moment";
const editFields = ["id", "name"];

export default {
  data() {
    return {
      stationList: [],
      curData: [],
      form: this.$form.createForm(this)
    };
  },
  props: {
    action: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["authUserInfo"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {},
  watch: {
    visible() {
      if (this.action == "edit") {
        this.updateCurRoute();
      }
    }
  },
  methods: {
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        let p = "";
        const params = {
          name: values.name,
          group_id: this.defaultInfo.defaultGroupId
        };
        if (this.action == "add") {
          p = addPatrolRoute;
          params.created_at = moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          params.id = values.id;
          params.created_at = moment(this.record.created_at).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          p = updatePatrolRoute;
        }

        try {
          let res = await p(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
        } catch (error) {
          this.$emit("update:visible", false);
          console.log(error);
        }
      });
    },
    updateCurRoute() {
      editFields.forEach(v => this.form.getFieldDecorator(v));
      const form_ = {};
      form_["id"] = this.record["id"];
      form_["name"] = this.record["name"];
      this.$nextTick(() => {
        this.form.setFieldsValue(form_);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
